import img1 from 'assets/img/gallery/2024_GaneshChaturthi.png';

export default [img1];
